export default __webpack_public_path__ + "09da7e05f3cb333bd442685e6815450e.png";